export function readableStreamFromArray<T>(list: T[]): ReadableStream<T> {
  return new ReadableStream({
    start: (controller) => {
      list.forEach((item) => controller.enqueue(item));
      controller.close();
    }
  });
}
